export const contactValues = {
  fullName: 'Radosław Krajewski',
  phoneNumber: '+48 519 780 399',
  email: 'Aktyn3@gmail.com',
  github: 'https://github.com/aktyn',
  linkedin: 'https://www.linkedin.com/in/aktyn',
  site: 'https://aktyn.github.io/',
}
